export const OnlineBookingErrors = {
  orgNotFound: 'Organization not found',
} as const;
